import React from 'react';
import Img from 'graphcms-image';

import Authors from './Authors';
import Paragraph from './renderers/Paragraph';
import Heading from './renderers/Heading';
import CardLink from './CardLink';
import Pill from './Pill';
import CardCTA from './CardCTA';

const BlogCard = ({
  authors,
  categories,
  coverImage,
  externalUrl,
  linkPath,
  id,
  friendlyPublishedOn,
  truncatedSubTitle,
  title,
}) => (
  <article className="flex flex-1" key={id}>
    <CardLink externalUrl={externalUrl} linkPath={linkPath}>
      {coverImage && (
        <div className="mb-2">
          <Img
            className="rounded-lg"
            image={coverImage}
            maxWidth={960}
            transforms={['quality=value:75']}
            withWebp
          />
        </div>
      )}
      <div className="-mt-6">
        <Heading children={title} level={4} className="mb-2" />
      </div>
      <div className="-mx-1 -my-1 flex flex-wrap">
        {categories.map(({ shortTitle }, index) => (
          <Pill label={shortTitle} key={index} />
        ))}
      </div>
      <Paragraph className="flex-grow">{truncatedSubTitle}</Paragraph>
      <div className="flex items-center justify-between">
        <CardCTA label="Read" />
        <div className="flex items-center">
          {authors && (
            <div className="flex items-center -ml-px mr-3">
              <Authors people={authors} expand={false} />
            </div>
          )}
          {friendlyPublishedOn && (
            <p className="text-cornflower">{friendlyPublishedOn}</p>
          )}
        </div>
      </div>
    </CardLink>
  </article>
);

export default BlogCard;
